import { useEffect } from 'react';
import { Alert } from '@nimbus-ds/components';
import { Text } from '@tiendanube/components';
import {
  useHasMetaplans,
  useSubscriptionsTranslation,
} from 'domains/Subscriptions';

function SubscriptionAlert() {
  const { hasMetaplans, fetchHasMetaplans } = useHasMetaplans();

  useEffect(() => {
    fetchHasMetaplans();
  }, [fetchHasMetaplans]);

  const t = useSubscriptionsTranslation('payments.advancedSettings');
  return (
    <Alert show={hasMetaplans} title={t('title')} appearance="warning">
      <Text>{t('description')}</Text>
    </Alert>
  );
}

export default SubscriptionAlert;
